import { Grid, Stack } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { GridItem } from "Components/Shared/GridItem";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { FirstDocumentUpload } from "Components/UserAccount/Shared/FirstDocumentUpload";
import { DOCUMENT_LEGEND_PROPS } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/Add/StatutoryBodyDocumentsFields";
import { SecondDocumentUpload } from "Components/UserAccount/Shared/SecondDocumentUpload";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";
import { getDocumentExpirationStatus } from "Utils/DocumentExpiration/documentExpirationUtils";

const FIELD_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.RelatedParties.Form.Fields
    .RelatedPartyFields;
const SECOND_DOCUMENT_RESOURCES = Resources.Onboarding.Steps.Documents;
const IDENTIFICATION_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form
    .PartyIdentification;
const EXPIRATION_RESOURCES = Resources.Components.DocumentExpirationWarning;

type Props = {
  partyData: PartyDto;
};

export const RelatedPartyDocumentsReupload = ({
  partyData: { publicID, partyIdentification },
}: Props) => {
  const { t } = useResource();
  const partyPublicID = publicID || "";
  const primaryValidTo = partyIdentification?.identificationValidTo;
  const secondaryValidTo = partyIdentification?.secondIdentificationValidTo;

  return (
    <Stack gap={4}>
      <PaperTitle>{t(FIELD_RESOURCES.Legend.Documents)}</PaperTitle>
      <FormSection
        legend={t(FIELD_RESOURCES.Legend.FirstDocument)}
        legendProps={DOCUMENT_LEGEND_PROPS}
        noMargins
      >
        <Stack gap={2}>
          {primaryValidTo && (
            <Grid container spacing={2}>
              <GridItem
                label={t(IDENTIFICATION_RESOURCES.IdentificationValidTo)}
                value={formatDate(primaryValidTo)}
              />
            </Grid>
          )}
          <FirstDocumentUpload
            partyPublicID={partyPublicID}
            isExpired={
              getDocumentExpirationStatus(primaryValidTo ?? null).isExpired
            }
          />
        </Stack>
      </FormSection>
      <FormSection
        legend={t(SECOND_DOCUMENT_RESOURCES.SecondDocumentTitle)}
        legendProps={DOCUMENT_LEGEND_PROPS}
        noMargins
      >
        <Stack gap={2}>
          {secondaryValidTo && (
            <Grid container spacing={2}>
              <GridItem
                label={t(EXPIRATION_RESOURCES.SecondDocumentValidTo)}
                value={formatDate(secondaryValidTo)}
              />
            </Grid>
          )}
          <SecondDocumentUpload
            partyPublicID={partyPublicID}
            isExpired={
              getDocumentExpirationStatus(secondaryValidTo ?? null).isExpired
            }
          />
        </Stack>
      </FormSection>
    </Stack>
  );
};
